<template>
    <aside>
        <div id="logo-wrapper" @click="goToHome()">
            <img src="/img/logo.png" class="img-responsive" />
        </div>
        <div id="workspace-swtcher" class="hide">
            <div class="workspace-logo">
                CO
            </div>
            <div class="workspace-name">
                Cocunat <span>Marcos Aguayo</span>
            </div>
        </div>
        <nav id="menu">
            <ul class="nav-app">
                <li :class="'nav-item ' + testsIsActive" @click="goToHome()"><i class="fas fa-flask"></i> API Tests</li>
            </ul>
            <span>Manage</span>
            <ul class="nav-app">
                <li :class="'nav-item ' + alertsIsActive" @click="goToAlerts()"><i class="far fa-bell"></i> Alerts</li>
                <li :class="'nav-item ' + profileIsActive" @click="goToProfile()"><i class="far fa-user"></i> Profile</li>
            </ul>
            <span>Billing</span>
            <ul class="nav-app">
                <li :class="'nav-item ' + plansIsActive" @click="goToPlans()"><i class="far fa-credit-card"></i> Plans & Billing</li>
                <li :class="'nav-item ' + invoicesIsActive" @click="goToInvoices()"><i class="fas fa-receipt"></i> Invoices</li>
            </ul>
        </nav>
        <span @click="logout()" style="display: block; position: absolute; bottom: 0px; left: 0px; height: 45px; background: #494949; width: 100%; line-height: 45px; color: #fff; padding-left: 15px; font-size: 14px; cursor: pointer;">
            <i class="fas fa-sign-out-alt" style="margin-right: 4px;"></i> Logout
        </span>
    </aside>
</template>

<script>
    let testsIsActive = "active"
    let alertsIsActive = ""
    let profileIsActive = ""
    let plansIsActive = ""
    let invoicesIsActive = ""

    export default {
        name: 'Sidebar',
        data(){
            return {
                testsIsActive: testsIsActive,
                alertsIsActive: alertsIsActive,
                profileIsActive: profileIsActive,
                plansIsActive: plansIsActive,
                invoicesIsActive: invoicesIsActive,
            }
        },
        methods: {
            logout: function(){
                localStorage.clear();
                window.location.reload()
            },
            goToProfile: function(){
                this.testsIsActive = ""
                this.alertsIsActive = ""
                this.profileIsActive = "active"
                this.plansIsActive = ""
                this.invoicesIsActive = ""
                this.$router.push({name: "profile"})
            },
            goToInvoices: function(){
                this.testsIsActive = ""
                this.alertsIsActive = ""
                this.profileIsActive = ""
                this.plansIsActive = ""
                this.invoicesIsActive = "active"
                this.$router.push({name: "invoices"})
            },
            goToHome: function(){
                this.testsIsActive = "active"
                this.alertsIsActive = ""
                this.profileIsActive = ""
                this.plansIsActive = ""
                this.invoicesIsActive = ""
                this.$router.push({name: "home"})
            },
            goToPlans: function(){
                this.testsIsActive = ""
                this.alertsIsActive = ""
                this.profileIsActive = ""
                this.plansIsActive = "active"
                this.invoicesIsActive = ""
                this.$router.push({name: "plans"})
            },
            goToAlerts: function(){
                this.testsIsActive = ""
                this.alertsIsActive = "active"
                this.profileIsActive = ""
                this.plansIsActive = ""
                this.invoicesIsActive = ""
                this.$router.push({name: "alerts"})
            }
        }
    }
</script>

<style scoped>
    #menu{
        padding: 20px 10px;
        color: #fff;
    }
    #menu ul{
        margin-bottom: 15px;
        padding: 3px 0px;
    }
    .nav-item{
        padding: 8px 10px;
        border-radius: 7px;
        margin-bottom: 5px;
        font-size: 14px;
        cursor: pointer;
    }
    .nav-item i{
        margin-right: 3px;
        height: 15px;
        width: 16px;
        text-align: center;
    }
    .nav-item.active,
    .nav-item:hover{
        background: #494949;
    }
    #menu span{
        text-transform: uppercase;
        font-size: 11px;
        margin-left: 10px;
    }
    aside{
        background: #323232;
        width: 180px;
        position: fixed;
        height: 100%;
    }
    #logo-wrapper{
        padding: 30px 22px;
        border-bottom: 1px solid #525252;
        cursor: pointer
    }
    .workspace-logo{
        background: #007d99;
        display: inline-block;
        width: 35px;
        height: 35px;
        border-radius: 7px;
        text-align: center;
        line-height: 35px;
        color: #fff;
        vertical-align: middle;
        font-size: 14px;
        margin-top: 1px;
    }
    .workspace-name{
        display: inline-block;
        width: 115px;
        vertical-align: middle;
        margin-left: 8px;
        font-size: 14px;
        color: #fff;
    }
    .workspace-name span{
        display: block;
        font-size: 11px;
    }
    #workspace-swtcher{
        padding: 15px 10px;
        border-bottom: 1px solid #525252;
    }
</style>
